import type { IconKey } from './icons';

export type NavKey =
  | 'hoc' | 'ontap' | 'congdong' | 'chat' | 'ai' | 'hoso'
  | 'kanaLib' | 'decks' | 'deckItems'
  | 'srsSettings' | 'account' | 'editProfile'
  | 'about' | 'privacy' | 'terms'
  | 'placeholder';

export interface NavItem {
  key: NavKey;
  label: string;
  ico: IconKey;
  hint?: string;
}

/** Mục chính — khớp bottom tab của mobile (Cộng đồng/Chat và AI ẩn được bằng feature flag). */
export const WEB_NAV_MAIN: NavItem[] = [
  { key: 'hoc', label: 'Học', ico: 'learn', hint: 'Lộ trình N5' },
  { key: 'ontap', label: 'Ôn tập', ico: 'review', hint: 'SRS & flashcard' },
  { key: 'congdong', label: 'Cộng đồng', ico: 'community', hint: 'Hỏi đáp & chia sẻ' },
  { key: 'chat', label: 'Chat', ico: 'chat', hint: 'Tin nhắn & nhóm học' },
  { key: 'ai', label: 'Trợ lý AI', ico: 'ai', hint: 'Chat & phát âm' },
  { key: 'hoso', label: 'Hồ sơ', ico: 'profile', hint: 'Tiến độ của bạn' },
];

/** Hai thư viện nằm trong tab Ôn tập của mobile; web cho shortcut ở sidebar. */
export const WEB_NAV_LIB: NavItem[] = [
  { key: 'kanaLib', label: 'Thư viện chữ Nhật', ico: 'kana' },
  { key: 'decks', label: 'Flashcard Minna', ico: 'deck' },
];

export interface PageMeta {
  title: string;
  sub?: string;
  /** Trang cha để nút back trên top bar quay về. */
  back?: NavKey;
}

export const WEB_PAGE_META: Record<NavKey, PageMeta> = {
  hoc: { title: 'Học', sub: 'Lộ trình N5 — Từ vựng & Ngữ pháp' },
  ontap: { title: 'Ôn tập', sub: 'SRS (ôn tập ngắt quãng) và flashcard tự học' },
  congdong: { title: 'Cộng đồng', sub: 'Hỏi đáp, chia sẻ và tìm bạn cùng học' },
  chat: { title: 'Chat', sub: 'Nhắn tin và học cùng nhóm' },
  ai: { title: 'Trợ lý AI', sub: 'Hỏi đáp theo bài học và chấm phát âm' },
  hoso: { title: 'Hồ sơ', sub: 'Tiến độ, thống kê và cài đặt' },
  kanaLib: { title: 'Thư viện chữ Nhật', sub: 'Ôn tự do bằng flashcard — không ảnh hưởng lịch SRS', back: 'ontap' },
  decks: { title: 'Flashcard Minna', sub: 'Tự chọn bài để ôn — không ảnh hưởng lịch SRS', back: 'ontap' },
  deckItems: { title: 'Bài', sub: 'Danh sách từ trong bài', back: 'decks' },
  srsSettings: { title: 'Cài đặt SRS', sub: 'Bật/tắt SRS · số thẻ mỗi lần ôn', back: 'ontap' },
  account: { title: 'Cài đặt', sub: 'Tài khoản, học tập, pháp lý', back: 'hoso' },
  editProfile: { title: 'Chỉnh sửa hồ sơ', back: 'account' },
  about: { title: 'Về Torii', back: 'account' },
  privacy: { title: 'Chính sách bảo mật', back: 'account' },
  terms: { title: 'Điều khoản sử dụng', back: 'account' },
  placeholder: { title: 'Sắp ra mắt', back: 'hoso' },
};

/** URL cho từng trang — tiếng Anh, cùng quy ước với API. Shell dùng React Router nhưng giữ mô hình `nav` một tầng. */
export const NAV_PATH: Record<NavKey, string> = {
  hoc: '/learn',
  ontap: '/review',
  congdong: '/community',
  chat: '/chat',
  ai: '/ai',
  hoso: '/profile',
  kanaLib: '/review/kana',
  decks: '/review/flashcards',
  deckItems: '/review/flashcards/unit',
  srsSettings: '/review/srs-settings',
  account: '/profile/settings',
  editProfile: '/profile/edit',
  about: '/profile/about',
  privacy: '/profile/privacy',
  terms: '/profile/terms',
  placeholder: '/coming-soon',
};

export const PATH_NAV: Record<string, NavKey> = Object.fromEntries(
  Object.entries(NAV_PATH).map(([k, v]) => [v, k as NavKey]),
) as Record<string, NavKey>;
